export const VerificationDocsType = Object.freeze({
    INVOICE: 'invoice',
    PASSPORT: 'passport',
    ID: 'id',
    DRIVER_LICENCE: 'driver',
    RESIDENCE_PERMIT: 'residence'
});